<template>
  <b-container>
    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top">
      <b-navbar-brand to="/">
        <img src="@/assets/logo.png" alt /> Customer Action Requests
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav v-if="hasUser">
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/" class="my-auto">Home</b-nav-item>
          <b-nav-item to="/approvalrequests" class="my-auto"
            >Approval Requests</b-nav-item
          >
          <b-nav-item-dropdown
            text="Maintenance"
            class="my-auto"
            right
            v-if="this.isAdmin()"
          >
            <b-dropdown-item to="/approvers">Approvers</b-dropdown-item>
            <b-dropdown-item to="/causes">Causes</b-dropdown-item>
            <b-dropdown-item to="/currencies">Currencies</b-dropdown-item>
            <!-- <b-dropdown-item to="/mortalityuploads">Mortality Uploads</b-dropdown-item> -->
            <b-dropdown-item to="/reasons">Reasons</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item class="my-auto">
            <b-avatar
              id="avatar"
              :src="userPhoto"
              v-if="hasUserPhoto"
            ></b-avatar>
            <b-avatar id="avatar" :text="userInitials" v-else></b-avatar>
            <b-popover
              target="avatar"
              placement="bottomleft"
              triggers="hover focus"
              :disabled.sync="disablePopover"
              ><b-container class="pa-0">
                <b-row no-gutters>
                  <b-col cols="12" class="text-right" @click="closeMenu">
                    <router-link :to="{ name: 'Signout' }">
                      Sign out
                    </router-link>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <h5>{{ this.user.displayName }}</h5>
                    <div class="user-principal-name">
                      {{ this.user.userPrincipalName }}
                    </div>
                    <div class="user-principal-name">
                      {{ `Divisions: ${getDivisions}` }}
                    </div>
                    <div class="user-principal-name">
                      Release: {{ `v1.0.0.${this.releaseVersion}` }}
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pt-2">
                  <b-col cols="12" align-self="center">
                    <userFeedback
                      :userPrincipalName="this.user.userPrincipalName"
                      @showSuccessful="showSuccess"
                      @showFailure="showFailed"
                      @feedbackClicked="feedbackClicked"
                    ></userFeedback>
                  </b-col>
                </b-row> </b-container
            ></b-popover>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
import userFeedback from "../UserFeedback.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    userFeedback,
  },
  data() {
    return {
      currentDateTime: new Date().getFullYear(),
      disablePopover: false,
    };
  },
  computed: {
    getDivisions() {
      let divisions = Array.from(this.divisions);
      if (divisions.filter((x) => x === undefined).length > 0) {
        return;
      }

      return this.divisions
        .map((d) => d.Abbreviation)
        .join(", ");
    },
    ...mapGetters(["divisions", "user", "userPhoto"]),
    releaseVersion() {
      let releaseName = process.env.VUE_APP_RELEASE_ID;

      let releaseNumber = parseInt(releaseName.replace("Release-", ""));

      return releaseNumber;
    },
    hasUser() {
      return this.user !== null && this.user !== undefined;
    },
    hasUserPhoto() {
      return this.userPhoto != null && this.userPhoto != undefined;
    },
    userInitials() {
      return this.hasUser
        ? this.user.givenName.substr(0, 1) + this.user.surname.substr(0, 1)
        : "";
    },
    title() {
      if (this.user === null || this.user === undefined) {
        return null;
      }

      return this.user.Title;
    },
    fullName() {
      if (this.user === null || this.user === undefined) {
        return null;
      }

      return this.user.FullName;
    },
    initials() {
      if (this.user === null || this.user === undefined) {
        return null;
      }

      return this.user.UserInitials;
    },
  },
  methods: {
    feedbackClicked(event) {
      this.disablePopover = event;
    },
    isAdmin() {
      if (this.user === null || this.user === undefined) {
        return false;
      }

      return true;
    },
    showSuccess(message) {
      this.$emit("showAlert", { message, color: "success" });
    },
    showFailed(message) {
      this.$emit("showAlert", { message, color: "danger" });
    },
    closeMenu() {
      this.$emit("closeMenu");
    },
  },
};
</script>
<style scoped>
.user-principal-name {
  font-size: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>